import {
  FilterDataType,
  GROUP_TYPE,
  IForwardToFilters,
  IRecentContacts,
  IUserDirectory,
  RECENT_CONTACTS_BUCKET,
  searchUsersByName,
  USER_TYPE,
} from "@home-health-notify/domain";

export enum TAB {
  "PATIENT" = 0,
  "INTERNAL" = 1,
  "PRIVATE" = 2,
}

// Patient and Internal are fetched (and cached per-tab) from the domain.
// Private has no bucket — see searchPrivateContacts below.
export function getBucketForTab(
  tabValue: TAB.PATIENT | TAB.INTERNAL,
): RECENT_CONTACTS_BUCKET {
  return tabValue === TAB.INTERNAL
    ? GROUP_TYPE.NON_PATIENT
    : GROUP_TYPE.PATIENT;
}

// The Private tab used to fetch its list from the recentContacts API, but
// that data is just the org's user directory, which is already loaded by
// the time any chat is open. Search it locally instead of refetching it.
// Matches the backend's own search: name only (firstName + lastName), not
// email/phone — the backend's recentContacts endpoint never searched those.
export function searchPrivateContacts(
  userDirectory: IUserDirectory,
  selectedRole: USER_TYPE | undefined,
  searchText: string,
): IRecentContacts[] {
  const filterData: FilterDataType = {
    userType: getUserFiltersByRole(selectedRole ?? USER_TYPE.USER),
    userRole: [],
  };
  const filtered = userDirectory.filterUserDirectory(filterData);
  return searchUsersByName(searchText, filtered);
}

export function setInitialFilters(
  tabValue: TAB,
  selectedRole?: USER_TYPE,
): IForwardToFilters {
  let updatedFilters: IForwardToFilters;
  switch (tabValue) {
    case TAB.PATIENT:
      updatedFilters = {
        search: "",
        groupType: GROUP_TYPE.PATIENT,
      };
      break;
    case TAB.INTERNAL:
      updatedFilters = {
        search: "",
        groupType: GROUP_TYPE.NON_PATIENT,
      };
      break;
    case TAB.PRIVATE:
      updatedFilters = {
        search: "",
        userType: getUserFiltersByRole(selectedRole ?? USER_TYPE.USER),
      };
      break;
    default:
      updatedFilters = {
        search: "",
        groupType: GROUP_TYPE.PATIENT,
      };
  }
  return updatedFilters;
}

export function getUserFiltersByRole(selectedRole: USER_TYPE) {
  let userFilters: USER_TYPE[] = [USER_TYPE.USER, USER_TYPE.STAFF];
  switch (selectedRole) {
    case USER_TYPE.ADMIN:
      userFilters.push(USER_TYPE.PATIENT, USER_TYPE.PHYSICIAN);
      return userFilters;
    case USER_TYPE.USER:
      userFilters.push(USER_TYPE.ADMIN);
      return userFilters;
    case USER_TYPE.STAFF:
      userFilters.push(USER_TYPE.PHYSICIAN, USER_TYPE.ADMIN, USER_TYPE.ADMIN);
      return userFilters;
    default:
      return (userFilters = []);
  }
}
